import { render } from "./Secured.vue?vue&type=template&id=2cfd58f5"
import script from "./Secured.vue?vue&type=script&lang=js"
export * from "./Secured.vue?vue&type=script&lang=js"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__